// 📄 components/StepInvoiceExits.tsx
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { InvoiceFormData } from '../../../../../services/commerce/integrationService';

interface StepInvoiceExitsProps {
  exitMRMH0002Active: boolean;
  swe2ObjectType: string;
  swe2Event: string;
  swe2ReceiverFunction: string;
  onChange: (field: keyof InvoiceFormData, value: any) => void;
  isInvalid: boolean;
}

export function StepInvoiceExits({ exitMRMH0002Active, swe2ObjectType, swe2Event, swe2ReceiverFunction, onChange, isInvalid }: StepInvoiceExitsProps) {
  return (
    <div className="space-y-4 animate-fadeIn">
      <div className="bg-blue-500/5 border border-blue-500/10 rounded-xl p-3 mb-2 space-y-1">
        <span className="text-[10px] font-bold text-blue-400 uppercase tracking-widest block">Ruta SPRO / Transacción SAP</span>
        <p className="font-mono text-xs text-gray-300">
          <span className="bg-zinc-800 px-1.5 py-0.5 rounded text-gray-400 font-bold mr-1.5">CMOD / SWE2</span>
          <span>ABAP Workbench → Enhancements (MRMH0002); Business Workplace → Business Object Event Linkages</span>
        </p>
      </div>

      <div>
        <h3 className="text-lg font-medium text-blue-400">4. Customer Exits & BTE Linkages</h3>
        <p className="text-sm text-gray-400">
          Activa el enhancement de factura y el vínculo de eventos que dispara el procesamiento posterior a la contabilización exitosa del IDoc de factura.
        </p>
      </div>

      <div className="bg-white/5 p-4 rounded-xl border border-white/5 space-y-4">
        <div className="flex items-center justify-between gap-4">
          <div>
            <label className="block text-sm font-medium text-white">Enhancement <code className="bg-black/30 px-1 rounded font-mono text-blue-400">MRMH0002</code> activo</label>
            <p className="text-xs text-gray-400 mt-0.5">
              Exits: <code className="bg-black/30 px-1 rounded font-mono">EXIT_SAPLMRMH_011/012/013/014/015</code>
            </p>
            <p className="text-xs text-gray-400 mt-0.5 font-mono">Includes: ZXM08U22, ZXM08U25, ZXM08U26</p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer flex-shrink-0">
            <input type="checkbox" checked={exitMRMH0002Active || false} onChange={(e) => onChange('exitMRMH0002Active', e.target.checked)} className="sr-only peer" />
            <div className="w-9 h-5 bg-zinc-700 rounded-full peer peer-checked:after:translate-x-full peer-checked:bg-blue-500 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all"></div>
          </label>
        </div>

        <div className="border-t border-white/5 pt-3 grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-xs font-medium text-gray-400 mb-1">
              Object Type (SWE2) <span className="text-red-400">*</span>
            </label>
            <input
              type="text"
              value={swe2ObjectType}
              onChange={(e) => onChange('swe2ObjectType', e.target.value.toUpperCase())}
              placeholder="IDPKINVOIC"
              className={`w-full bg-zinc-800 border rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-blue-500 ${
                isInvalid && !swe2ObjectType ? 'border-red-500' : 'border-white/10'
              }`}
            />
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-400 mb-1">Event</label>
            <input
              type="text"
              value={swe2Event}
              onChange={(e) => onChange('swe2Event', e.target.value.toUpperCase())}
              placeholder="MASSINPUTFINISHED"
              className="w-full bg-zinc-800 border border-white/10 rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-blue-500"
            />
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-400 mb-1">Receiver Function Module</label>
            <input
              type="text"
              value={swe2ReceiverFunction}
              onChange={(e) => onChange('swe2ReceiverFunction', e.target.value.toUpperCase())}
              placeholder="ARBCIG_INB_IDOC_SUCCESS_EVENT"
              className="w-full bg-zinc-800 border border-white/10 rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-blue-500"
            />
          </div>
        </div>
      </div>

      <div className="bg-yellow-500/10 border border-yellow-500/20 rounded-xl p-4 text-yellow-400 flex gap-3 text-sm">
        <AlertTriangle className="w-5 h-5 flex-shrink-0" />
        <div>
          <p className="font-semibold">Linkage activo (Enabled) en SWE2</p>
          <p className="text-xs text-yellow-500/80 mt-0.5">
            Verifica que el checkbox "Linkage Activated" quede marcado en SWE2 — un event linkage inactivo no dispara la función receptora aunque esté correctamente configurado.
          </p>
        </div>
      </div>
    </div>
  );
}
